import router from 'next/router';
import fetchNext from '@features/api/fetchNext';
import getPublicEnv from '@utils/getPublicEnv';
import { EXPERTSENDER_ENABLED } from '@config/index';
type NewsletterResponse = {
  status: string;
  detail: string;
};
class NextNewsletterApi {
  public email: string | undefined;
  public locale: string | undefined;
  public componentName: string | undefined;
  private endpoints = {
    subscribe: () => 'newsletter/subscribe'
  };
  private static getLocale() {
    const isServerSide = typeof window === 'undefined';
    if (isServerSide) return process.env.DEFAULT_LOCALE;
    const {
      locale
    } = router;
    return locale || getPublicEnv('NEXT_PUBLIC_DEFAULT_LOCALE');
  }
  public async newsletterSend(email: string, componentName: string): Promise<NewsletterResponse> {
    const method = 'POST';
    this.email = email;
    this.locale = NextNewsletterApi.getLocale();
    this.componentName = componentName;
    if (EXPERTSENDER_ENABLED !== 'true') {
      return {
        status: 'disabled',
        detail: ''
      };
    }
    const {
      json
    } = await fetchNext(this.endpoints.subscribe(), {
      method,
      body: JSON.stringify({
        email,
        componentName
      })
    }, this.locale);
    return json as NewsletterResponse;
  }
}
export default new NextNewsletterApi();